export interface CatalogGrade {
	GradeId: number | null;
	GradeName: string;
	IsActive: boolean;
	CreatedBy: string | null;
	CreatedDate: Date | null;
	ModifiedBy: string | null;
	ModifiedDate: Date | null;
}

export const CATALOG_GRADE_INITIAL_VALUES: CatalogGrade = {
	GradeId: null,
	GradeName: "",
	IsActive: true,
	CreatedBy: null,
	CreatedDate: null,
	ModifiedBy: null,
	ModifiedDate: null,
};
